import { render, staticRenderFns } from "./OpenLicense.vue?vue&type=template&id=66445a34"
import script from "./OpenLicense.vue?vue&type=script&lang=js"
export * from "./OpenLicense.vue?vue&type=script&lang=js"
import style0 from "./OpenLicense.vue?vue&type=style&index=0&id=66445a34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports